// @see https://github.com/nuxt/nuxt.js/issues/421#issuecomment-288671748
import { defineNuxtPlugin } from '#imports';
import SvgIcon from '~/components/svg-icon.vue';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('SvgIcon', SvgIcon as any);
});
